"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Slider = exports.FILLED_COLOR = exports.EMPTY_COLOR = void 0;
var _react = _interopRequireWildcard(require("react"));
var _Field = _interopRequireDefault(require("../Field"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const FILLED_COLOR = exports.FILLED_COLOR = "#0066CC";
const EMPTY_COLOR = exports.EMPTY_COLOR = "#D9D9D9";
/**
 * This is the [React](https://reactjs.org/) component for the Vanilla [Slider](https://vanillaframework.io/docs/patterns/slider).
 *
 * Sliders should be used to let a user specify a numeric value between a defined
minimum and maximum value, however the precise value is not especially important.
 */
const Slider = _ref => {
  var _navigator;
  let {
    caution,
    disabled = false,
    error,
    help,
    id,
    inputDisabled = false,
    label,
    max,
    min,
    onChange,
    required = false,
    showInput = false,
    ...inputProps
  } = _ref;
  const validationId = (0, _react.useId)();
  const helpId = (0, _react.useId)();
  const defaultSliderId = (0, _react.useId)();
  const sliderId = id || defaultSliderId;
  const hasError = !!error;
  let style = {};
  if ((_navigator = navigator) !== null && _navigator !== void 0 && (_navigator = _navigator.userAgent) !== null && _navigator !== void 0 && _navigator.includes("AppleWebKit")) {
    var _inputProps$value;
    // Range inputs on Webkit browsers don't have a built-in "filled" portion,
    // so instead it is handled here as a background.
    const val = (_inputProps$value = inputProps.value) !== null && _inputProps$value !== void 0 ? _inputProps$value : inputProps.defaultValue;
    const filledPercentage = "".concat((Number(val) - min) / (max - min) * 100, "%");
    style = {
      background: "linear-gradient(\n        to right,\n        ".concat(FILLED_COLOR, " 0%,\n        ").concat(FILLED_COLOR, " ").concat(filledPercentage, ",\n        ").concat(EMPTY_COLOR, " ").concat(filledPercentage, ",\n        ").concat(EMPTY_COLOR, " 100%\n      )")
    };
  }
  return /*#__PURE__*/_react.default.createElement(_Field.default, {
    caution: caution,
    error: error,
    help: help,
    forId: sliderId,
    helpId: helpId,
    label: label,
    required: required,
    validationId: validationId
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "p-slider__wrapper"
  }, /*#__PURE__*/_react.default.createElement("input", _extends({
    "aria-describedby": help ? helpId : null,
    "aria-errormessage": hasError ? validationId : null,
    "aria-invalid": hasError,
    disabled: disabled,
    id: sliderId,
    max: max,
    min: min,
    onChange: onChange,
    required: required,
    style: style,
    type: "range"
  }, inputProps)), showInput && /*#__PURE__*/_react.default.createElement("input", _extends({
    "aria-describedby": help ? helpId : null,
    "aria-errormessage": hasError ? validationId : null,
    "aria-invalid": hasError,
    className: "p-slider__input",
    disabled: disabled || inputDisabled,
    max: max,
    min: min,
    onChange: onChange,
    type: "number"
  }, inputProps))));
};
exports.Slider = Slider;
var _default = exports.default = Slider;